import React from 'react';
import PropTypes from 'prop-types';
import { compose, prop } from 'ramda';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import connect from 'app/libs/connect';
import renderIf from 'app/enhancers/renderIf';
import S from 'app/features/newLanding/components/newProductComparison/Product/Price.styled';
import Heading from 'app/components/layout/Heading.styled';
import {
  isFreeProduct,
  productBillingPeriodKey,
} from 'app/features/products/selectors';
import {
  havePlansLoaded,
  productPriceAmount,
  productCurrency,
} from 'app/features/plans/selectors';
import { userCountryCode } from 'app/features/user/selectors';

const UI = ({ isFree, amount, currency, billingPeriodKey }) => (
  <>
    <Heading size="l" as={S.Price} isFree={isFree} data-t="product-price">
      {isFree ? (
        <FormattedMessage id="landing_plans_free_price" />
      ) : (
        <>
          <FormattedNumber
            style="currency"
            currency={currency}
            value={amount}
          />
          /<FormattedMessage id={billingPeriodKey} />
        </>
      )}
    </Heading>
  </>
);

UI.propTypes = {
  isFree: PropTypes.bool,
  amount: PropTypes.string,
  currency: PropTypes.string,
  billingPeriodKey: PropTypes.string,
};

UI.defaultProps = {
  isFree: false,
  amount: '',
  currency: '',
  billingPeriodKey: '',
};

UI.displayName = 'Price';

const state = {
  havePlansLoaded,
  countryCode: userCountryCode,
  isFree: isFreeProduct,
  amount: productPriceAmount,
  currency: productCurrency,
  billingPeriodKey: productBillingPeriodKey,
};

const Price = compose(connect(state), renderIf(prop('havePlansLoaded')))(UI);

export { UI };

export default Price;
